import React, { useState } from "react";
import { formInputStyles } from "../../constants/styles";
import { right } from "../../../utils/directions";
import styled, { useTheme } from "styled-components";

const PasswordInput = ({
  name,
  id,
  value,
  onChange,
  placeholder,
  style = formInputStyles,
  disabled = false,
  autoComplete = "current-password",
  ...props
}) => {
  //const { direction } = useTheme();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="position-relative w-100">
      <input
        type={showPassword ? "text" : "password"}
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={style}
        disabled={disabled}
        autoComplete={autoComplete}
        //dir={direction}
        {...props}
      />
      <PasswordToggleButton
        type="button"
        className="btn position-absolute"
        onClick={() => setShowPassword(!showPassword)}
      >
        <i
          className={`fi fi-rr-${
            showPassword ? "eye-crossed" : "eye"
          }`}
          style={{
            fontSize: "14px",
            color: "#666",
            position: "relative",
            top: "1px",
          }}
        >        </i>
      </PasswordToggleButton>
    </div>
  );
};

export default PasswordInput;

// Styled Components
const PasswordToggleButton = styled.button`
  //${right}: 8px;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`;
